import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class SubCategoryService {
    async saveNewSubCategory(data) {
        const response = await axios.post(Config.apiBasePath + '/saveSubCategory', data, {headers: authHeader()});
        return response;
    }

    async updateSubCategory(data) {
        const response = await axios.post(Config.apiBasePath + '/updateSubCategory', data, {headers: authHeader()});
        return response;
    }

    async getSubCategoriesByCategoryId(data) {
        const response = await axios.get(Config.apiBasePath + '/subCategories/' + data, {headers: authHeader()});
        return response;
    }

    async getSubCategoriesByCategoryIdWithFilter(categoryId, param) {
        const response = await axios.post(Config.apiBasePath + '/subCategoriesWithFilter/' + categoryId, null, {
            headers: authHeader(),
            params: param
        });
        return response;
    }

    async unpublishSubcategory(param) {
        const response = await axios.get(Config.apiBasePath + '/unpublishSubcategory',
            {headers: authHeader(), params: param});
        return response.data;
    }
}

export default new SubCategoryService();